import React, { useState, useEffect, useCallback } from 'react';
import './reviews.css'; // Import the single CSS file

// --- Sample Data for Review Cards ---
const sampleReviewsData = [
     {
        id: 1, name: "dilpesh kalal", avatarUrl: "https://lh3.googleusercontent.com/a-/ALV-UjXR9n3xlFYqJdu5WWOfjROh65fKU2FrL5nx32_-eJv5NvlYWmP8Pw=w72-h72-p-rp-mo-br100", rating: 5, timeAgo: "3 Months ago", text: "Excellent experience at this newly constructed hospital! The staff were not only good but also extremely cooperative. I was impressed that my visit was completed within 20 minutes - efficient and hassle-free. Highly recommend! 👏💉"
     },
       {
        id: 6, name: "Ashok suthar", avatarUrl: "https://lh3.googleusercontent.com/a-/ALV-UjVtfqg_uXhX-Ve13CrVKrJ5QP3b4sUhLbRrP_DHXmOLqSmhDSeSqQ=w72-h72-p-rp-mo-br100", rating: 5, timeAgo: "a month ago", text: "Best hospital and best doctor special thanks to Dr.Mahesh Rathod sir very polite with kindness truly satisfied"
     },
     {
        id: 7, name: "Mustak khan kawas", avatarUrl: "https://lh3.googleusercontent.com/a-/ALV-UjWym2hMEvyrenjg_ctS5NZ6SW-SfQHbCDlPKgbHnJmr4m_mf5QwBg=w72-h72-p-rp-mo-br100", rating: 5, timeAgo: "6 days ago", text: "Best hospital in Balotra Treatment is excellent Hygiene at its best"
    },
     {
        id: 8, name: "Mahesh Rathod", avatarUrl: "https://lh3.googleusercontent.com/a-/ALV-UjWim6E4FI0LrOYOpcR5-VOhUdO9DJXLxq5Huujbs8kHnllL8ErgsA=w72-h72-p-rp-mo-ba2-br100", rating: 5, timeAgo: "1 day ago", text: "Big hospital with almost all investigations under one roof.. with all the facilities ranging from general medicine, obstetrics and gynaecology, infertility, dental, emergency services etc.. must visit hospital"
     },
     {
        id: 2, name: "Omprakash Sharma", avatarUrl: "https://via.placeholder.com/42/3D405B/FFFFFF?text=O", rating: 5, timeAgo: "3 months ago", text: "Had a wonderful experience at Hitkari Hospital’s OB/GYN department! 👶 Dr. Mahesh Rathore was incredibly kind and supportive, making us feel completely at ease during every step. His expertise and genuine care truly made a difference. The hospital is super clean and well-equipped for all our needs. Highly recommend! 🌟 #OBGYNCare #KindDoctors #DrMaheshRathore #HitkariHospital"
     },
     {
        id: 3, name: "Jogendra Jawa", avatarUrl: "https://via.placeholder.com/42/CE93D8/FFFFFF?text=J", rating: 5, timeAgo: "3 months ago", text: "Just had an amazing experience at Hitkari Hospital! 💖 The doctors and nurses were so kind and took great care of us. The hospital is super clean and has everything we needed. Thank you, Hitkari Hospital! 🌟 #HealthcareHeroes #TopNotchCare #HitkariHospital"
     },
     {
        id: 4, name: "ritesh kumar", avatarUrl: "https://via.placeholder.com/42/80CBC4/FFFFFF?text=R", rating: 5, timeAgo: "a month ago", text: "Hitkari Hospital is a very good hospital in western Rajasthan with a team of very experienced doctors and nursing staff, especially Dr. Mahesh Rathore ms (Gyn) who is very good-natured"
     },
     {
        id: 5, name: "Mukesh Kumar", avatarUrl: "https://via.placeholder.com/42/FFAB91/FFFFFF?text=M", rating: 5, timeAgo: "3 months ago", text: "Hitkari Hospital provided excellent care and top-notch facilities. The doctors and staff were compassionate and attentive. Highly recommended for quality healthcare in our rural area."
     },
];
// --- End Sample Data ---

// --- SVGs (Used by both widget and review cards if needed) ---
// Google 'G' Logo (can be reused or specific versions for each component)
const GoogleGLogoSvg = ({ className = "" }) => ( // Added className prop for flexibility
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path fill="#4285F4" d="M23.49,12.27 C23.49,11.48 23.42,10.73 23.28,10 L12,10 L12,14.51 L18.47,14.51 C18.21,15.99 17.39,17.25 16.2,18.09 L16.2,21.09 L20.19,21.09 C22.34,19.19 23.49,16.03 23.49,12.27 Z"/>
    <path fill="#34A853" d="M12,24 C15.24,24 17.99,22.92 20.19,21.09 L16.2,18.09 C15.07,18.89 13.67,19.38 12,19.38 C9.06,19.38 6.56,17.51 5.52,14.81 L1.38,14.81 L1.38,17.9 C3.54,22.02 7.46,24 12,24 Z"/>
    <path fill="#FBBC05" d="M5.52,14.81 C5.27,14.07 5.14,13.28 5.14,12.42 C5.14,11.57 5.28,10.78 5.52,10.03 L5.52,6.93 L1.38,6.93 C0.53,8.61 0,10.44 0,12.42 C0,14.4 0.53,16.23 1.38,17.9 L5.52,14.81 Z"/>
    <path fill="#EA4335" d="M12,5.04 C13.84,5.04 15.39,5.68 16.59,6.81 L20.27,3.3 C17.99,1.24 15.24,0 12,0 C7.46,0 3.54,2.98 1.38,6.93 L5.52,10.03 C6.56,7.34 9.06,5.04 12,5.04 Z"/>
  </svg>
);

// Star Icon for Widget
const WidgetStarIcon = ({ filled }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill={filled ? "#fbbc05" : "#e0e0e0"} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z"/>
  </svg>
);
// --- End SVGs ---


// --- Google Review Widget Component (Prefixed) ---
const GoogleReviewWidget = ({ ratingValue = 4.3, reviewCount = 141, reviewUrl = "" }) => {
  const displayStars = 5;

  return (
    <div className="reviewlink-widget-container">
      <div className="reviewlink-rating-display-section">
        <div className="reviewlink-logo-and-rating">
            <GoogleGLogoSvg /> {/* Using the common SVG */}
            <div className="reviewlink-rating-details">
            <span className="reviewlink-rating-label">Google Rating</span>
            <div className="reviewlink-stars-and-value">
                <span className="reviewlink-numeric-rating">{ratingValue.toFixed(1)}</span>
                <div className="reviewlink-stars-container">
                {[...Array(displayStars)].map((_, i) => (
                    <WidgetStarIcon key={i} filled={true} />
                ))}
                </div>
            </div>
            </div>
        </div>
        <div className="reviewlink-review-count-section">
         <a href='https://www.google.com/maps/place/Hitkari+hospital+%26+surgical+centre/@25.8332524,72.246477,17z/data=!4m18!1m9!3m8!1s0x3943e8d204ffb9b1:0x53a79c16ccad96c!2sHitkari+hospital+%26+surgical+centre!8m2!3d25.8332476!4d72.2490519!9m1!1b1!16s%2Fg%2F11bzth3gsr!3m7!1s0x3943e8d204ffb9b1:0x53a79c16ccad96c!8m2!3d25.8332476!4d72.2490519!9m1!1b1!16s%2Fg%2F11bzth3gsr?entry=ttu&g_ep=EgoyMDI1MDUxNS4xIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D'> <span className="reviewlink-review-count-text">{reviewCount} Reviews</span></a>
        </div>
      </div>

      <a href="https://www.google.com/search?sca_esv=aefbd55d9f72913f&sxsrf=AHTn8zohgkUc8ZL2qCjFkUiSND-dgeA9mw:1747999423304&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzXem51knCyFORtTtznYVqWw2FJVlPIYyFysRlVBAECRwVgZKIQ7P_60IOlykYDyGPZZAKccI8ybaD7HTWvnlJ8d39zVd8dSljKlHcTWk0nTCFJxVnNNHnhSNGVNeNpRuPDIwdoE%3D&q=Hitkari+hospital+%26+surgical+centre+Reviews&sa=X&ved=2ahUKEwj5iMalvbmNAxWuyDgGHcqCNloQ0bkNegQIKhAD&biw=1920&bih=911" className="reviewlink-view-review-button" target="_blank" rel="noopener noreferrer">
        <GoogleGLogoSvg /> {/* Using the common SVG */}
        <span className="reviewlink-button-text">View Review</span>
      </a>
    </div>
  );
};
// --- End Google Review Widget Component ---


// --- Review Card Helper Components (Original, with small G logo class fix) ---
const ReviewCardStarRating = ({ rating }) => { // Renamed to avoid conflict
  const totalStars = 5;
  return (
    <div className="star-rating" aria-label={`Rating: ${rating} out of 5 stars`}>
      {[...Array(totalStars)].map((_, index) => (
        <span key={index} className={index < rating ? "star-filled" : "star-empty"}>★</span>
      ))}
    </div>
  );
};

const ReviewCard = ({ review }) => {
  const avatarPlaceholder = `https://ui-avatars.com/api/?name=${encodeURIComponent(review.name)}&background=random&color=fff&size=42`;

  return (
    <div className="review-card">
      <GoogleGLogoSvg className="review-card-google-logo" /> {/* Added specific class for card logo */}
      <div className="review-card-header">
        <img
          src={review.avatarUrl || avatarPlaceholder}
          alt={`${review.name}'s avatar`}
          className="review-avatar"
          onError={(e) => { e.target.onerror = null; e.target.src = avatarPlaceholder; }}
        />
        <div className="review-user-info">
          <span className="review-user-name">{review.name}</span>
          <span className="review-time">{review.timeAgo}</span>
        </div>
      </div>
      <ReviewCardStarRating rating={review.rating} />
      <p className="review-body">{review.text}</p>
    </div>
  );
};
// --- End Review Card Helper Components ---


// --- Main Reviews Component ---
const Reviews = ({ reviewsData = sampleReviewsData, interval = 5000, widgetReviewUrl = "#" }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const reviewsToShow = 4;

  const advanceReviews = useCallback(() => {
    if (reviewsData.length <= reviewsToShow) return;
    setIsVisible(false);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = prevIndex + reviewsToShow;
        return nextIndex >= reviewsData.length ? 0 : nextIndex;
      });
      setIsVisible(true);
    }, 600);
  }, [reviewsData.length, reviewsToShow]);

  useEffect(() => {
    if (reviewsData.length <= reviewsToShow) return;
    const timer = setInterval(advanceReviews, interval);
    return () => clearInterval(timer);
  }, [reviewsData.length, reviewsToShow, interval, advanceReviews]);

  const getDisplayReviews = () => {
      if (!reviewsData || reviewsData.length === 0) return [];
      if (reviewsData.length <= reviewsToShow) return reviewsData;
      const endIndex = currentIndex + reviewsToShow;
      const slicedReviews = reviewsData.slice(currentIndex, endIndex);
      if (slicedReviews.length < reviewsToShow) {
          const remainingNeeded = reviewsToShow - slicedReviews.length;
          return [...slicedReviews, ...reviewsData.slice(0, remainingNeeded)];
      }
      return slicedReviews;
  };

  const displayReviews = getDisplayReviews();

  return (
    // This div acts as the page wrapper for styling if this component is the main content
    <div className="reviewlink-page-wrapper"> 
        <div className="reviews-showcase-container">
         
            
            <div
                className="reviews-wrapper"
                style={{ opacity: isVisible ? 1 : 0 }}
            >
                {displayReviews.length > 0 ? (
                displayReviews.map((review) => (
                    <ReviewCard key={review.id} review={review} />
                ))
                ) : (
                <p className="reviews-loading-text">Loading reviews...</p> /* Added class for styling */
                )}
            </div>
               {/* Google Review Widget is now part of this component */}
            <GoogleReviewWidget 
                ratingValue={4.3} // You can make these props of Reviews component
                reviewCount={141} // Or fetch this data
                reviewUrl={widgetReviewUrl}
            />
        </div>
    </div>
  );
};

export default Reviews;